import { DownloadK8sAgentView } from '../view/DownloadK8sAgentView';
import { templateDownloadK8sAgent } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { DownloadK8sAgentWebComponent } from '../component/DownloadK8sAgentWebComponent';
import { DownloadK8sAgentRepository } from '../repository/DownloadK8sAgentRepository';
import { DownloadK8sAgentData, DownloadK8sEvents } from '../types/download-k8s-agent-data';

export class DownloadK8sAgentController extends BaseWebComponentController {
  public component: DownloadK8sAgentWebComponent;
  public view: DownloadK8sAgentView;
  public viewConstructor: typeof DownloadK8sAgentView;
  public dataRepository: DownloadK8sAgentRepository;
  public dataRepositoryConstructor: typeof DownloadK8sAgentRepository;
  private currentCompanyId: string;

  constructor(component: DownloadK8sAgentWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: DownloadK8sAgentView,
      viewTemplate: templateDownloadK8sAgent,
      dataRepositoryConstructor: DownloadK8sAgentRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$companyFormField,
        event: DownloadK8sEvents.CompanyDropdownValidated,
        callback: this.onCompanyChanged,
      },
      {
        element: this.view.dom.$wrapper,
        event: DownloadK8sEvents.DownloadK8sPageOpened,
        callback: () => {
          this.currentCompanyId = '';
        },
      },
    ];
  }

  public async getDataForView(): Promise<DownloadK8sAgentData> {
    // on initial load, fetch the data based on if current company is a partner or customer

    // if partner, get a list of company IDs that have KSPM enabled for the dropdown validation.
    //   skip the script API call since we will not display the script yet.
    if (Application.Main.company.isPartner()) {
      const companyIdsWithKspm = await this.dataRepository.getAvailableCompanyIdsWithKspm();

      return {
        success: true,
        companyIdsWithKspm,
      };
    }

    // if customer, we will display the script on page load, so get the required data.
    return await this.dataRepository.getK8sScriptData(Application.Main.getUserCompany().id);
  }

  private async onCompanyChanged(event: WebComponentEvent): Promise<void> {
    if (!event.detail.selectedValue) {
      return;
    }

    const selectedCompanyId = event.detail.selectedValue;

    // if the selected company ID is the same as the current one, do nothing
    if (this.currentCompanyId !== selectedCompanyId) {
      this.currentCompanyId = selectedCompanyId;

      if (event.detail.valid) {
        // if selection is valid, set the script
        try {
          this.view.setK8sScriptInput(selectedCompanyId, await this.dataRepository.getK8sScriptData(selectedCompanyId));
        } catch (error) {
          this.view.buildErrorView();
        }
      } else {
        // if selection is invalid, reset the script
        this.view.setK8sScriptPlaceholder();
      }
    }
  }
}
